import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { ProcessPlanService } from './process-plan.service'

@Directive({
  selector: '[appProcessPlanSelect]',
})
export class ProcessPlanSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const processPlanService = inject(ProcessPlanService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'process.plans.plan'
    this.select.dataSource = processPlanService
    this.select.sorts = [new Sort('name', 'asc')]
    this.select.icon = 'account_tree'
  }
}
